const initialState = {
  isButtonVisible: false,
};

const buttonVisibilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_BUTTON_VISIBILITY":
      return {
        ...state,
        isButtonVisible: action.payload,
      };
    default:
      return state;
  }
};

export default buttonVisibilityReducer;
